/**
 * Created by dmitry on 24.06.2025
 */

Placements.ENTRIES["updateStickersBookSeason"] = {
    priority: -1000,
    type: Placements.FREE_FOCUS_MAIN,

    action: function () {
        cleverapps.stickersBook.updateSeason();
    }
};

Placements.ENTRIES["stickersRewardWindow"] = {
    type: Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_OTHER,
    priority: 2,

    filter: function () {
        return cleverapps.stickersBook.isAvailable() && cleverapps.stickersBook.newStickers && cleverapps.stickersBook.newStickers.length > 0;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "StickersRewardWindow",
            action: function (f) {
                new StickersRewardWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};